import { encrypt } from '@common/oneclub/utils'
import { udbSentryReport } from '../services/http'

export const UDB_CONF = {
  baseURL: '/udb',
  appid: process.env.APPID,
  subappid: process.env.SUB_APPID,
  encrypt,
  onXhrError: ({ code, message, url }) => {
    udbSentryReport(message, { config: { url, method: '', data: { code, message } }, status: 0 })
  },
}
